var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024.003,
    viewBox: "0 0 1024 1024.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M74.614,221.695a147.536,147.536,0,0,0,96.917,138.3l28.331,7.2,17.532-108.91L205.3,251.64a34.13,34.13,0,1,1,23.291,3.489l7.848,38.352A73.277,73.277,0,1,0,174.6,277.833l-6.087,37.814a107.954,107.954,0,0,1,53.183-201.888V74.614c-81.1,0-147.081,65.978-147.081,147.081",
    transform: "translate(-74.614 -74.614)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M78.329,102.58l23.237,31.507A176.741,176.741,0,0,1,207.232,99.395c107.78,0,151.534,73.464,166.78,110.706l-31.976,3.817c-18.3-41.283-55.624-70.773-102.647-80.222l-7.716,38.376c38.411,7.721,67.847,33.459,78.739,68.855l4.81,15.614,108.827-12.981-4.839-21.211c-.367-1.62-38.963-162.1-211.977-162.1a215.658,215.658,0,0,0-128.9,42.33",
    transform: "translate(-78.329 -60.25)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M97.62,232.763A216.965,216.965,0,0,0,159.8,384.976l-22.386,24.108a252.459,252.459,0,0,1-51.02-74.316L50.651,350.735a292,292,0,0,0,74.937,100.846l14.3,12.384,75.872-81.729L200.08,369a178.221,178.221,0,0,1-4.829-268.243L168.936,71.771A217.847,217.847,0,0,0,97.62,232.763",
    transform: "translate(-50.651 -71.771)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M45.529,151.063A289.153,289.153,0,0,0,59.88,241.3l37.2-12.194A252.064,252.064,0,0,1,89.762,100.61L51.41,92.757a291.172,291.172,0,0,0-5.881,58.306",
    transform: "translate(-45.529 -92.757)",
    fill: "#acacac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M48.255,247.838l37.334,11.773C118.568,154.977,214.5,84.674,324.312,84.674A247.337,247.337,0,0,1,438.9,112.4l17.962-34.79A290.217,290.217,0,0,0,324.312,45.529c-126.98,0-237.921,81.3-276.057,202.309",
    transform: "translate(-48.255 -45.529)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M134.011,88.276a250.7,250.7,0,0,1,106.693,205,251.059,251.059,0,0,1-80.2,183.6l-14.288,13.241,77.834,84.831,14.43-13.338a365.727,365.727,0,0,0,74.11-95.713L278.1,447.378A326.393,326.393,0,0,1,225.937,519.1l-24.984-27.235a290.45,290.45,0,0,0,78.9-198.585A289.91,289.91,0,0,0,156.495,56.226Z",
    transform: "translate(-134.011 -56.226)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M165.884,212.651l35.92,15.555a362.964,362.964,0,0,0,28.722-114.772l-39.013-3.21a323.853,323.853,0,0,1-25.63,102.427",
    transform: "translate(-165.884 -110.224)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M485.016,105.169l5.089,18.755c8.994,33.15,14.2,59.735,14.2,97.534,0,220.359-179.277,399.636-399.637,399.636v39.145c241.948,0,438.781-196.838,438.781-438.781A359.688,359.688,0,0,0,532.729,132.5l33.747-9.4A427.882,427.882,0,0,1,577.7,221.457a472.826,472.826,0,0,1-21.75,142.2l37.339,11.758a511.961,511.961,0,0,0,23.55-153.96c0-43.446-5.338-82.825-17.321-127.675L594.41,74.675Z",
    transform: "translate(-104.673 -74.675)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M143.039,389.844l15.55,35.92A511.083,511.083,0,0,0,425.682,158.515l-35.935-15.531a472.1,472.1,0,0,1-246.709,246.86",
    transform: "translate(-143.039 -142.984)",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M12.695,169.587A512.3,512.3,0,0,0,462.75,437.071a511.245,511.245,0,0,0,166.208-27.577L616.27,372.463a472.271,472.271,0,0,1-153.52,25.463A473.149,473.149,0,0,1,47.074,150.851Z",
    transform: "translate(-12.695 -150.851)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M0,413.183A508.139,508.139,0,0,0,45.868,625.327L81.489,609.1A473.478,473.478,0,0,1,203.131,55.059L177.545,25.427A512.027,512.027,0,0,0,0,413.183",
    transform: "translate(0 -25.427)",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M42.9,51.78,66.023,83.364a475.106,475.106,0,0,1,58.7-36.708L106.444,12.043A514.855,514.855,0,0,0,42.9,51.78",
    transform: "translate(-42.898 -12.043)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M259.38,0A509.35,509.35,0,0,0,64.934,38.2L79.8,74.415A473.562,473.562,0,0,1,650.948,246.7L683.33,224.71A512.129,512.129,0,0,0,259.38,0Z",
    transform: "translate(-64.934 -0.001)",
    fill: "#acacac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M152.559,63.3A396.042,396.042,0,0,1,290.964,243.155l6.635,17.258,106.718-34.188-7.369-19.313a511.7,511.7,0,0,0-37.55-77.858L325.71,148.988A472.192,472.192,0,0,1,352.568,201.7l-32.074,10.271A434.535,434.535,0,0,0,175.429,31.535Z",
    transform: "translate(-152.559 -31.535)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M124.727,55.523a388.389,388.389,0,0,1,108.807,44.517l20.13-33.571a427.548,427.548,0,0,0-119.758-49Z",
    transform: "translate(-124.727 -17.47)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M15.224,113.277A438.89,438.89,0,0,0,409.992,518.629l3.782-38.964C219.245,460.778,68.054,305.53,54.276,110.517Z",
    transform: "translate(-15.224 -110.517)",
    fill: "#475067"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M15,198.3H54.144A400.846,400.846,0,0,1,68.676,91.1L30.965,80.624A439.516,439.516,0,0,0,15,198.3",
    transform: "translate(-14.999 -80.624)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M375.9,17.689A438.082,438.082,0,0,0,21.183,292.772l36.429,14.317A399.026,399.026,0,0,1,359.935,59.627l1.884,33.6A355.917,355.917,0,0,0,202.51,164.348l24.25,30.728a317.081,317.081,0,0,1,157.982-65.7l18.192-2.226-6.292-112Z",
    transform: "translate(-21.183 -15.149)",
    fill: "#acacac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M30,315.047a364.748,364.748,0,0,0,93.443,244.047l29.128-26.158A325.609,325.609,0,0,1,69.141,315.047c0-90.634,34.981-174.57,98.488-236.355L140.335,50.635C69.18,119.852,30,213.755,30,315.047",
    transform: "translate(-29.996 -50.635)",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M439.757,156.685c-33.738,22.122-70.524,33.42-115.79,35.548l1.845,39.1c45.535-2.138,83.921-12.424,119.273-32.128l20.458,28.708a325.382,325.382,0,0,1-157.929,40.705A324.5,324.5,0,0,1,79.867,175.969L52.544,204A363.4,363.4,0,0,0,307.615,307.759a364.255,364.255,0,0,0,196.736-57.43l17.326-11.093L455.5,146.366Z",
    transform: "translate(-52.544 -146.366)",
    fill: "#acacac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M338.118,109v18.256c0,56.872-45.4,98.145-107.936,98.145v39.144c77.164,0,136.859-49.983,145.9-118.95l31.076-2.163c-10.373,86.906-84.381,152.258-176.973,152.258-38.278,0-74.561-13.955-74.9-14.087L142.028,276.4,72.434,361.3l20.947,11.254a289.9,289.9,0,0,0,136.8,34.315V367.725a251.3,251.3,0,0,1-96.56-19.323l21.065-25.693c16.23,4.971,44.9,12.13,75.5,12.13,121.886,0,217.365-93.326,217.365-212.472V101.385Z",
    transform: "translate(-72.434 -101.385)",
    fill: "#556ee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M119.255,69.79c147.267,30.288,254.9,159.788,254.9,319.532H413.3c0-97.832-37.084-189.543-104.438-258.242A354.6,354.6,0,0,0,126.913,31.556Z",
    transform: "translate(-119.255 -31.556)",
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M101.673,15V127.525h19.572a331.588,331.588,0,0,1,51.485,4.032L177.9,92.823a364.808,364.808,0,0,0-37.08-3.924V54.618a399.567,399.567,0,0,1,42.217,4.291l6.043-38.675A440.92,440.92,0,0,0,121.245,15Z",
    transform: "translate(-101.673 -14.999)",
    fill: "#556ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2534",
    "data-name": "Group 2534",
    transform: "translate(1053 -3018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    "data-name": "Group 2533",
    transform: "translate(-1053 3018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2532",
    "data-name": "Group 2532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(364.94 364.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 220.355,
    height: 292.581,
    transform: "translate(0 0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(383.08 294.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 345.72,
    height: 196.29,
    transform: "translate(0 0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(247.742 350.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 165.107,
    height: 392.194,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(222.699 453.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 51.548,
    height: 148.539,
    transform: "translate(0 0)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(235.987 222.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 408.61,
    height: 214.082,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(655.463 274.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 178.582,
    height: 518.724,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(811.343 539.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 64.642,
    height: 117.982,
    transform: "translate(0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(511.833 365.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 512.167,
    height: 585.563,
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(699.563 699.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 282.643,
    height: 282.78,
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(62.118 737.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 616.262,
    height: 286.22,
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 124.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 203.131,
    height: 599.9,
    transform: "translate(0 0)",
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(209.828 58.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 81.822,
    height: 71.321,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(317.392 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 618.396,
    height: 246.704,
    transform: "translate(0 0)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(746.143 154.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 251.758,
    height: 228.878,
    transform: "translate(0 0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(610.068 85.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 128.937,
    height: 82.57,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(74.492 540.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 398.55,
    height: 408.111,
    transform: "translate(0 0)",
    fill: "#475067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(73.391 394.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 53.677,
    height: 117.673,
    transform: "translate(0 0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(103.649 74.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 381.752,
    height: 291.94,
    transform: "translate(0 0)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(146.773 247.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 137.632,
    height: 508.458,
    transform: "translate(0 0)",
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(256.946 715.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 469.133,
    height: 161.393,
    transform: "translate(0)",
    fill: "#acacac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(354.242 495.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 375.112,
    height: 305.484,
    transform: "translate(0 0)",
    fill: "#556ee0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(583.185 154.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 294.044,
    height: 357.766,
    transform: "translate(0 0)",
    fill: "#535353"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(497.315 73.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 87.405,
    height: 116.558,
    transform: "translate(0 0)",
    fill: "#556ee0"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/whiteLogo.72c632306e09f36d0ec10b012cf83507.svg";
export { ForwardRef as ReactComponent };